// Ordenar tallas (igual que en ProductInfo.js)
export const sortSizes = (sizesRaw) => {
    const priority = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];

    return sizesRaw.slice().sort((a, b) => {
        const aVal = typeof a === 'string' ? a.toUpperCase() : String(a).toUpperCase();
        const bVal = typeof b === 'string' ? b.toUpperCase() : String(b).toUpperCase();

        const aIndex = priority.indexOf(aVal);
        const bIndex = priority.indexOf(bVal);

        const isANumeric = !isNaN(Number(aVal));
        const isBNumeric = !isNaN(Number(bVal));

        if (isANumeric && isBNumeric) return Number(aVal) - Number(bVal);
        if (!isANumeric && !isBNumeric) {
            if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
            return aVal.localeCompare(bVal);
        }
        return isANumeric ? 1 : -1;
    });
};

// Fisher-Yates shuffle (igual que Home.js)
export function shuffleArray(arr) {
    return arr
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
}

// Debounce simple
export const debounce = (fn, delay = 250) => {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), delay);
    };
};

export const ITEMS_PER_LOAD = 20;

// Genera un ID único para filas del carrito (evita colisiones con Date.now() en renders simultáneos)
let _uidCounter = 0;
export const uid = () => `${Date.now()}_${++_uidCounter}`;
